import { cx } from '@linaria/core';
import React from 'react';
import { tab, active, tabGroup } from './Tabs.styles';

export const Tabs = ({ tabs, activeTab, setActiveTab, className, activeTabClassName, ...rest }: TabProps): JSX.Element => (
  <div className={cx(tabGroup, className)} {...rest}>
    {tabs.map((t) => (
      <div
        role="presentation"
        key={t.id}
        data-testid={`tab-${t.id}`}
        data-active={t.id === activeTab}
        className={cx(tab, t.id === activeTab && cx(active, activeTabClassName))}
        onClick={() => setActiveTab(t.id)}
      >
        {t.title}
      </div>
    ))}
  </div>
);

interface TabProps extends React.HTMLAttributes<HTMLDivElement> {
  tabs: { id: string; title: React.ReactNode }[];
  activeTab: string;
  setActiveTab: (v: string) => void;
  activeTabClassName?: string;
}
